import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "viewer-wrap" }
const _hoisted_2 = { ref: "canvasEl" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "values" }
const _hoisted_6 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_file_uploader = _resolveComponent("app-file-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isShowSectionInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createElementVNode("div", {
              class: "swatch",
              style: _normalizeStyle({ background: _ctx.currentHex })
            }, null, 4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[0] || (_cache[0] = _createElementVNode("strong", null, "RGB:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.currentRgb.join(', ')), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createElementVNode("strong", null, "HEX:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.currentHex), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_app_button, {
          severity: "secondary",
          raised: "",
          icon: ['fas', 'undo'],
          onClick: _ctx.resetImage
        }, null, 8, ["onClick"]),
        _createVNode(_component_app_button, {
          severity: "secondary",
          raised: "",
          icon: ['fas', 'plus'],
          onClick: _ctx.zoomPlus
        }, null, 8, ["onClick"]),
        _createVNode(_component_app_button, {
          severity: "secondary",
          raised: "",
          icon: ['fas', 'minus'],
          onClick: _ctx.zoomMinus
        }, null, 8, ["onClick"]),
        _createVNode(_component_app_file_uploader, {
          "is-show-sign": false,
          "is-title": false,
          onSelect: _ctx.onFileSelected
        }, null, 8, ["onSelect"])
      ])
    ])
  ]))
}